import { FlexContainer } from '@act/storybook';
import { Outlet } from 'react-router-dom';
import ReportsNav from './ReportsNav';

const REPORTS_CONTENT_MAX_WIDTH = '1152px';

/**
 * Shell layout with header navigation and page outlet for reports routes.
 */
const ReportsLayout = () => {
  return (
    <div className="reports-app-layout">
    <FlexContainer
      direction="column"
      width="100%"
      minHeight="100vh"
      height="100vh"
      overflow="hidden"
      backgroundColor="#f7f6f3"
    >
      <div className="reports-app-nav">
        <ReportsNav />
      </div>
      <FlexContainer
        direction="column"
        width="100%"
        maxWidth={REPORTS_CONTENT_MAX_WIDTH}
        margin="0 auto"
        padding={3}
        flexGrow={1}
        minHeight="0"
        height="auto"
        overflowY="auto"
        overflowX="hidden"
        gap={2}
      >
        <Outlet />
      </FlexContainer>
    </FlexContainer>
    </div>
  );
};

export default ReportsLayout;
